module.exports = __webpack_public_path__ + "img/card_3_ref_2.dff2fd6e.jpg";